module.exports = __webpack_public_path__ + "static/img/NatureExplorer.9c05f3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ui/reports/NatureExplorer.png
// module id = YkBY
// module chunks = 1